import { Action, Dispatch } from 'redux'
import { hideLoadingAction, showLoadingAction } from 'reducks/loading/actions'
import axios from 'axios'
import { ACCEPT_UPDATE_INVITATION_ENDPOINT } from 'constants/urls'
import { push } from 'connected-react-router'

const acceptUpdateInvitation = (token: string) => {
  return async (dispatch: Dispatch<Action>) => {
    dispatch(showLoadingAction())
    try {
      await axios.post(
        ACCEPT_UPDATE_INVITATION_ENDPOINT,
        { token },
        {
          headers: {
            'Content-Type': 'application/json',
            'Access-Control-Allow-Origin': '*',
          },
        }
      )
      dispatch(hideLoadingAction())
      dispatch(push('/register/complete?type=update'))
    } catch (e) {
      dispatch(hideLoadingAction())
      if (axios.isAxiosError(e)) {
        console.error(e.response)
      } else {
        console.error(e)
      }
      dispatch(push('/register/error'))
    }
  }
}

export default acceptUpdateInvitation
